import { useState } from "react";
import { useSelector } from "react-redux";
import { useGetAllQuizzesQuery } from "../../slices/fun_stuff/quizSlice";
import { Button, Card, Col, Row } from "react-bootstrap";
import Loader from "../Loader";
import Message from "../Message";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown, faRightToBracket } from '@fortawesome/free-solid-svg-icons';

const levels = {
    'elementary': 'Elementary',
    'high_school': 'High School',
    'honors': 'Honors',
    'university': 'University',
};

const QuizList = ({ onQuizSelect, hideAnswers }) => {
    const [ showQuizzes, setShowQuizzes ] = useState(true);

    const { quizList } = useSelector((state) => state.quizAuth);
    const { data: quizzes, isLoading, error } = useGetAllQuizzesQuery({ skip: quizList });

    async function handleQuizClick(e, quiz) {
        e.preventDefault();
        try {
            onQuizSelect(quiz);
            showQuizzesBtn(e);
            hideAnswers();
            resetAnswers();
        } catch (err) {
            console.error("Error fetching quiz:", err);
        }
    }

    function resetAnswers() {
        const radios = document.querySelectorAll('input[type="radio"]:checked');
        radios.forEach(radio => radio.checked = false);
      }
      

    function showQuizzesBtn(e) {
        e.preventDefault();
        setShowQuizzes(!showQuizzes);
    }

    if (isLoading ) return <Loader />;
    if (error) return <Message variant='danger'>{error?.data?.message || error.error}</Message>;

    return (
        <Card>
            <Card.Header className="card-header-dark">
            Choose a previously generated quiz
            </Card.Header>
            <div className="text-center my-4">
                <Button className={`quiz-btn mx-0 ${!showQuizzes ? 'active' : ''}`} onClick={(e) => showQuizzesBtn(e)}>
                    {showQuizzes ? (
                        <>
                        Show me the quizzes
                        <FontAwesomeIcon icon={faChevronDown} className="ms-1"/>
                        </>
                        ) : (
                        <>
                        Hide these shenanigans 
                        <FontAwesomeIcon icon={faChevronUp} className="ms-1"/>
                        </>
                        )
                    }
                </Button>
            </div>
            <Row className={`available-quizzes ${!showQuizzes ? '' : 'hidden'}`}>
                {( quizList || quizzes)?.map((quiz) => (
                <Col key={quiz.id} xs={6} md={4} lg={3}>
                    <Card className="shadow-sm m-1">
                        <Card.Header className={`card-header-${quiz.level} px-2`}>
                        {levels[quiz.level]}
                        </Card.Header>
                        <Card.Body className="d-flex flex-column justify-content-between">
                        <div>
                            <Card.Text className="mb-1">
                            <strong>Topic:</strong> {quiz.topic}
                            </Card.Text>
                            <Card.Text className="mb-2">
                            <strong>Questions:</strong> {quiz.questions.length}
                            </Card.Text>
                        </div>
                        <Button 
                            className="quiz-btn-dark py-1"
                            onClick={(e) => handleQuizClick(e, quiz)}
                        >
                            <FontAwesomeIcon icon={faRightToBracket} className="me-2"/>Take this quiz
                        </Button>
                        </Card.Body>
                    </Card>
                </Col>
                ))}
            </Row>
        </Card>
    );
};

export default QuizList;